import React from "react";
import { Scene, TourData } from "../../../Types";
import { getLanguageFile } from "../../common/GetLanguageFile";

export function TransformationInfo() {
  return (
    <div className="transformation-overlay">
      Hold LMB to drag
      <br />
      Press RMB to place
    </div>
  );
}

export const Warnings = (props: { scene: Scene; tourData: TourData }) => {
  const { scene, tourData } = props;

  const shouldFirstBeVisible = React.useMemo(() => {
    if (!scene?.hotspots?.filter((one) => one.type === "transition").length)
      return true;
    else if (
      !tourData?.scenes
        .map((scn) => {
          return scn.hotspots;
        })
        .flat()
        .filter((spt) => spt.type === "transition")
        .some((spot) => spot.target === scene?.id) &&
      tourData?.startingScene !== scene?.id
    )
      return true;
    else return false;
  }, [scene?.hotspots, tourData, scene?.id]);

  const shouldScndBeVisible = React.useMemo(() => {
    if (!scene?.hotspots?.filter((one) => one.type === "transition").length)
      return true;
    else return false;
  }, [scene]);

  const shouldThirdBeVisible = React.useMemo(() => {
    if (
      !tourData.scenes
        ?.map((scn) => {
          return scn?.hotspots;
        })
        ?.flat()
        .filter((spt) => spt.type === "transition")
        .some((spot) => spot.target === scene?.id) &&
      tourData.startingScene !== scene?.id
    )
      return true;
    else return false;
  }, [tourData, scene?.id]);

  const a = getLanguageFile("experience.inaccessible");
  return (
    <>
      {scene && (
        <div hidden={!shouldFirstBeVisible} className="transformation-overlay">
          {shouldScndBeVisible && (
            <small>⚠ {getLanguageFile("experience.no_exit")} </small>
          )}
          {shouldThirdBeVisible && (
            <small>⚠ {getLanguageFile("experience.inaccessible")}</small>
          )}
        </div>
      )}
    </>
  );
};
